/**
 * Constants used throughout the browser SDK
 */

// Default authentication URLs
export const DEFAULT_AUTH_URL = "https://connect.phantom.app/login/start";

// Default authentication API base URL
export const DEFAULT_AUTH_API_BASE_URL = "https://auth.phantom.app";

// Default API URLs
export const DEFAULT_WALLET_API_URL = "https://api.phantom.app/v1/wallets";

// Default embedded wallet type
export const DEFAULT_EMBEDDED_WALLET_TYPE = "user-wallet";
